import { useMutation, useQueryClient } from '@tanstack/react-query';
import { medicalRecordsApi, type ExamPriority, type ExamItem } from '@/api';

export function useCreateExamRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      medicalRecordId: string;
      patientId: string;
      doctorId: string;
      appointmentId: string;
      exams: ExamItem[];
      priority: ExamPriority;
      instructions?: string;
    }) => medicalRecordsApi.createExamRequest(data),
    onSuccess: (newExamRequest) => {
      queryClient.invalidateQueries({
        queryKey: ['medical-records', 'record', newExamRequest.medicalRecordId],
      });
    },
  });
}
